import React from "react";
import withStyles from '@mui/styles/withStyles';
import UnitBox from "./unit-box";
import CourseProgress from "./course-progress";
import {Certificates} from "./certificates";
import CourseCredits from "./course-credits";

const styles = (theme) => ({
  root: {
    color: "#fff",
    height: 800,
  },
});

const Achievements = ({ classes }) => {
  return (
    <div data-testid="achievements">
      <div
        style={{ marginBottom: 100, minHeight: "100vh" }}
        className="scrollable"
        datatest-id="achievements"
      >
        <UnitBox />
        <CourseProgress />
        <CourseCredits />
        <Certificates />
      </div>
    </div>
  );
};

export default withStyles(styles)(Achievements);
